import script from "./winItem2.vue?vue&type=script&setup=true&lang=js"
export * from "./winItem2.vue?vue&type=script&setup=true&lang=js"

import "./winItem2.vue?vue&type=style&index=0&id=5feb5b5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5feb5b5c"]])

export default __exports__